export function responsibleDecisionMakerFields() {
    return [
        {
            type: "branch",
            field: "responsibleDecisionMaker",
            label: "Who is the responsible decision maker?",
            branches: [
                {
                    fieldValue: "person_completing_form",
                    label: "Me",
                    fields: [],
                    fieldsOwned: [],
                },
                {
                    fieldValue: "another_individual",
                    label: "Another individual",
                    fieldsOwned: ["responsibleDecisionMakerName"],
                    fields: [
                        {
                            type: "textbox",
                            field: "responsibleDecisionMakerName",
                            label: "Name of the responsible decision maker",
                        },
                    ],
                },
            ],
        },
        {
            type: "label",
            bannerType: "info",
            label: [
                "To rely on the protection in section 5 of the Mental Capacity Act, the decision maker must have taken reasonable steps to establish whether the person lacks capacity for this decision, reasonably believe that the person lacks capacity, and reasonably believe that the act is in the person's best interests.",
            ],
        },
    ];
}
//# sourceMappingURL=responsibleDecisionMakerFields.js.map